import React, { useCallback, useMemo } from 'react';

import { TextInput } from '@repo/ui/components/Inputs';
import { themeStyle } from '@repo/ui/theming';

import { JsonFieldType } from '../schema';
import { fieldTypeMatchesValue } from '../utils';

import { AiTextToolTextInputProps } from './types';

const textInputCustomStyles = {
  width: '100%',
  backgroundColor: themeStyle.varInkSuperLight,
  borderRadius: '10px',
};

const AiTextToolTextInput: React.FC<AiTextToolTextInputProps> = ({
  field,
  value: currentValue,
  onChange,
  disabled,
  error,
}) => {
  const { key, type, label, placeholder, required } = field;
  const value = useMemo(
    () => (fieldTypeMatchesValue(type, currentValue) ? currentValue : ''),
    [type, currentValue]
  );

  const handleInputChange = useCallback(
    (newValue: string) => {
      onChange<JsonFieldType.Text>(key, newValue);
    },
    [onChange, key]
  );

  return (
    <TextInput
      key={key}
      disabled={disabled}
      errorMessage={error}
      label={`${label}${required ? '*' : ''}`}
      placeholder={placeholder}
      theme={textInputCustomStyles}
      value={value}
      onChanging={handleInputChange}
    />
  );
};

export default AiTextToolTextInput;
